module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-autocomplete"
  }, _vm._l((_vm.filteredAndLimitedItems), function(item, item_idx) {
    return _c('div', {
      class: {
        'kiwi-autocomplete-item': true,
        'kiwi-autocomplete-item--selected': item.idx === _vm.selected_idx
      },
      on: {
        "click": function($event) {
          _vm.selected_idx = item.idx;
          _vm.selectCurrentItem()
        }
      }
    }, [(item.type === 'user') ? [_c('span', {
      staticClass: "kiwi-autocomplete-item-value"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "u-link kiwi-autocomplete-item-action",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openQuery(item.text)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('send_message')))])] : (item.type === 'command') ? [_c('span', {
      staticClass: "kiwi-autocomplete-item-value"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "u-link kiwi-autocomplete-item-description"
    }, [_vm._v(_vm._s(item.description))])] : [_c('span', {
      staticClass: "kiwi-autocomplete-item-value"
    }, [_vm._v(_vm._s(item.text))])]], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14fa29d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoComplete.vue
// module id = 478
// module chunks = 2